
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class ClientFieldDataTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(hidden: JQuery, opt: any) {
            super(hidden, opt);

            this.addOption("bigint", "Int64 (bigint)");
            this.addOption("bit", "Boolean (bit)");
            this.addOption("date", "Date");
            this.addOption("datetime", "Date/Time (datetime)");
            this.addOption("datetime2", "Date/Time 2 (datetime2)");
            this.addOption("datetimeoffset", "Date/Time with Offset (datetimeoffset)");
            this.addOption("decimal", "Decimal");
            this.addOption("float", "Double (float)");
            this.addOption("int", "Int32 (int)");
            this.addOption("money", "Money");
            this.addOption("nvarchar", "Unicode String (nvarchar)");
            this.addOption("numeric", "Numeric");
            this.addOption("real", "Single (real)");
            this.addOption("smallint", "Int16 (smallint)");
            this.addOption("time", "Time (time)");
            this.addOption("tinyint", "Byte (tinyint)");
            this.addOption("uniqueidentifier", "GUID (uniqueidentifier)");
            this.addOption("varbinary", "Array of Bytes (varbinary)");
			this.addOption("varchar", "Ansi String (varchar)");
			this.addOption("sql_variant", "Variant (sql_variant)");
        }
    }
}